import type { Mission } from '../missions.ts'

export const fbi: Mission = {
  id: "fbi",
  name: "Federal Bureau of Investigation",
  short: "FBI",
  call: "Investigation",
  kind: "subagency",
  parent: "doj",
  url: "https://www.fbi.gov/",
  established: 1908,
  palette: {
    primary: "#004990",
    secondary: "#001444",
    accent: "#ffd520",
  },
  colorSource: {
    kind: "seal",
    url: "https://commons.wikimedia.org/wiki/File:Seal_of_the_Federal_Bureau_of_Investigation.svg",
  },
  motif: "scales",
  mission: {
    text: "Our mission is to protect the American people and uphold the Constitution of the United States.",
    url: "https://www.fbi.gov/about/mission",
  },
  fact: {
    text: "A memo dated July 26, 1908, from Attorney General Charles J. Bonaparte is celebrated as the official birth of the FBI.",
    url: "https://www.fbi.gov/history/brief-history",
  },
  seal: {
    file: "public/seals/fbi.png",
    source: "https://commons.wikimedia.org/wiki/File:Seal_of_the_Federal_Bureau_of_Investigation.svg",
  },
  identifier: {
    about: "https://www.fbi.gov/about",
    accessibility: "https://www.fbi.gov/accessibility",
    foia: "https://www.fbi.gov/services/information-management/foipa",
    noFear: "https://www.justice.gov/jmd/eeo-program-status-report",
    oig: "https://oig.justice.gov/",
    performance: "https://www.justice.gov/doj/budget-and-performance",
    privacy: "https://www.fbi.gov/privacy-policy",
  },
  media: {
    photos: [
      {
        file: "/media/fbi-academy.jpg",
        small: "/media/fbi-academy-sm.jpg",
        alt: "Aerial view of the FBI Academy at Quantico, its buildings set among autumn forest in red, orange, and gold, with lakes in the distance.",
        title: "FBI Academy, Quantico, Virginia",
        creator: "Federal Bureau of Investigation",
        source: "https://commons.wikimedia.org/wiki/File:FBI_Academy.jpg",
        license: "Public domain (U.S. government work)",
      },
      {
        file: "/media/fbi-hq-night.jpg",
        small: "/media/fbi-hq-night-sm.jpg",
        alt: "The J. Edgar Hoover Building at dusk, its tiered concrete facade lit from within above streaks of passing traffic.",
        title: "J. Edgar Hoover Building at night, Washington, D.C.",
        creator: "Federal Bureau of Investigation",
        source: "https://commons.wikimedia.org/wiki/File:FBI_Headquarters_at_night.jpg",
        license: "Public domain (U.S. government work)",
      },
    ],
  },
}
